const PreviewsDescriptions = ({ titles, descriptions, activeCategory }) => {
  if (!activeCategory || !descriptions) return <></>;

  const categories = Object.keys(descriptions);

  const descriptionBlocks = categories.map((category, key) => {
    return (
      <div key={key}
        className={`previews__description ${activeCategory === category ? 'previews__description_active' : ''}`}>
        {titles[category] ? <h3>{titles[category]}</h3> : <></>}
        {descriptions[category] ? <p>{descriptions[category]}</p> : <></>}
      </div>
    );
  });

  return <>{descriptionBlocks}</>;
};

export default PreviewsDescriptions;
